import { useState } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [subscribeStatus, setSubscribeStatus] = useState<"idle" | "submitting" | "done">("idle");

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubscribeStatus("submitting");
    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);
    const honeypot = formData.get("website_alt") as string;
    if (honeypot && honeypot.trim() !== "") {
      setSubscribeStatus("done");
      setEmail("");
      return;
    }
    try {
      await fetch("https://readdy.ai/api/form/d90dncgbhec1he3opim0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ email: formData.get("email") as string }).toString(),
      });
    } catch (_) {
      // silently handle
    }
    setSubscribeStatus("done");
    setEmail("");
    setTimeout(() => setSubscribeStatus("idle"), 3000);
  };

  const footerCategories = categories.slice(8, 12);

  return (
    <footer className="bg-foreground-950 text-background-50 rounded-t-2xl mt-14">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        {/* Top Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[2fr_1fr_1.5fr] gap-10 py-14">
          {/* Subscribe */}
          <div>
            <h3 className="font-heading text-2xl text-background-50 mb-3">Stay Updated</h3>
            <p className="text-sm text-background-50/60 leading-relaxed mb-6 max-w-sm">
              Get notified when we add new products to the itaobuy spreadsheet. No spam, just fresh finds.
            </p>
            <form onSubmit={handleSubscribe} data-readdy-form="" className="relative">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address"
                required
                className="w-full bg-transparent border-b border-background-50/30 pb-3 text-sm text-background-50 placeholder:text-background-50/40 outline-none focus:border-background-50/60 transition-colors"
              />
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
              />
              <button
                type="submit"
                disabled={subscribeStatus !== "idle"}
                className="mt-4 px-5 py-2 rounded-full bg-background-50 text-foreground-950 text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-50"
              >
                {subscribeStatus === "done" ? "Subscribed ✓" : subscribeStatus === "submitting" ? "Sending..." : "Subscribe →"}
              </button>
            </form>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold text-background-50/80 mb-4">Categories</h4>
            <div className="flex flex-col gap-2">
              {footerCategories.map((cat) => (
                <a
                  key={cat.slug}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-50/60 hover:text-background-50/90 transition-colors underline decoration-background-50/20 hover:decoration-background-50/40 whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          {/* Info */}
          <div>
            <h4 className="text-sm font-semibold text-background-50/80 mb-4">Contact</h4>
            <p className="text-sm text-background-50/60 mb-1">hello@itaobuy.wtf</p>
            <p className="text-sm text-background-50/60 mb-4">Response within 24 hours</p>
            <h4 className="text-sm font-semibold text-background-50/80 mb-2 mt-6">Disclaimer</h4>
            <p className="text-xs text-background-50/50 leading-relaxed">
              Itaobuy.wtf is an independent product discovery guide. We are not affiliated with Taobao, 1688, or any listed marketplace. All product links redirect to kaspreadsheet.com.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between py-5 border-t border-background-50/10 gap-3">
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors underline">Twitter / X</a>
            <a href="#" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors underline">Instagram</a>
            <a href="#" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors underline">Pinterest</a>
          </div>
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} itaobuy.wtf — Your China product spreadsheet guide
          </p>
          <div className="flex items-center gap-4">
            <Link to="/" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors underline">Home</Link>
            <Link to="/article/itaobuy-spreadsheet-guide" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors underline">SEO Guide</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}